import * as yup from "yup";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-])|(\\([0-9]{2,3}\\)[ \\-])|([0-9]{2,4})[ \\-])?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const addcategary = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("name is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("ar name is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)",
      )
      .required("Status is required"),
    position: yup
      .number()
      .required("Position is required")
      .min(1, "Position must be at least 1")
      .max(50, "Position must be less than or equal to 50"),
  });

export const addcategary1 = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    gender: yup
      .number()
      .oneOf([1, 2, 3], "Gender must be 1 (Male), 2 (Female), or 3 (Unisex)")
      .required("This field is required"),
    female_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    position: yup
      .number()
      .required("This field is required")
      .typeError("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)",
      )
      .required("This field is required"),
    home_view: yup.string().required("This field is required"),
  });

export const addcategary2 = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    gender: yup
      .number()
      .oneOf([1, 2, 3], "Gender must be 1 (Male), 2 (Female), or 3 (Unisex)")
      .required("This field is required"),
    male_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    female_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    position: yup
      .number()
      .required("This field is required")
      .typeError("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)",
      )
      .required("This field is required"),
    home_view: yup.string().required("This field is required"),
  });

export const addsubcategary = (flag) =>
  yup.object({
    category_ids: yup
      .array()
      .of(
        yup
          .number()
          .integer("Category id must be an integer")
          .positive("Category id must be positive"),
      )
      .min(1, "At least one category must be selected")
      .required("Category is required"),
    title: yup
      .string()
      .required("name is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("AR name is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)",
      )
      .required("Status is required"),
    position: yup
      .number()
      .required("Position is required")
      .min(1, "Position must be at least 1")
      .max(50, "Position must be less than or equal to 50"),
  });

export const addbusiness = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("This Field is required")
      .required("This Field is required"),
    country_code: yup.string().required("This Field is required"),
    mobile_number: yup
      .string()
      .matches(/^[0-9]+$/, "This Field is required")
      .required("This Field is required"),
    address: yup.string().required("This Field is required"),
    website: yup
      .string()
      .test("is-url-valid", "This Field is required", (value) => {
        if (!value) return false;
        return /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+$/.test(value);
      })
      .required("This Field is required"),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    // logo: yup.mixed().required('This Field is required'),
    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("This Field is required"),
    logo: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
  });

export const update_business = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    hours: yup
      .array()
      .test(
        "hours",
        "Please Select Opening  time and Closing time",
        function (value) {
          if (!value || !Array.isArray(value)) return true;
          return !value.some(
            (slot) => !slot.opening_time || !slot.closing_time,
          );
        },
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),

    address: yup.string().required("This Field is required"),
    website: yup.string().matches(
      // /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w .-]*)*\/?$/,
      "Enter a valid website URL",
    ),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    first_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),

    last_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),
  });

export const BusinessPasswordUpdate = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    hours: yup
      .array()
      .test(
        "hours",
        "Please Select Opening  time and Closing time",
        function (value) {
          if (!value || !Array.isArray(value)) return true;
          return !value.some(
            (slot) => !slot.opening_time || !slot.closing_time,
          );
        },
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),

    address: yup.string().required("This Field is required"),
    website: yup.string().matches(
      // /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w .-]*)*\/?$/,
      "Enter a valid website URL",
    ),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    first_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),

    last_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("This Field is required"),
  });

export const addadmin = (update) =>
  yup.object({
    first_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),

    last_name: yup
      .string()
      .matches(/^[A-Za-z]+$/, "Only alphabets are allowed")
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0,
      ),
    mobile_number: yup
      .string()
      .min(9, "Minimum of 9 digits should be there")
      .max(10, "Maximum of 10 numbers")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
      ),
  });

export const hoursValidationSchema = yup.array().of(
  yup.object().shape({
    day: yup.number().required(),
    opening_time: yup
      .string()
      .test(
        "unique-time",
        "Duplicate shift times are not allowed on the same day",
        function (value, context) {
          const { hours } = this.options.context;
          const currentHour = context.parent;
          const duplicate = hours.filter(
            (h) =>
              h.day === currentHour.day &&
              h.opening_time === value &&
              h !== currentHour,
          );
          return duplicate.length === 0;
        },
      )
      .required("This Field is required"),
    closing_time: yup.string().required("This Field is required"),
  }),
);

export const adddriver = (flag) =>
  yup.object({
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    mobile_number: yup
      .string()
      .min(9, "Minimum of 9 digits should be there")
      .max(10, "Maximum of 10 numbers")
      .required("mobile number is required"),

    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
    car_model: yup
      .string()
      .required("This field is required")
      .matches(
        /^[a-zA-Z0-9\s]+$/,
        "Car model should only contain letters and numbers",
      ),
    car_color: yup
      .string()
      .required("This field is required")
      .matches(/^[a-zA-Z0-9\s]+$/, "Only letters and numbers are allowed"),
    car_number: yup
      .string()
      .required("This field is required")
      .matches(/^[a-zA-Z0-9\s]+$/, "Only letters and numbers are allowed"),
    nationality: yup.string().required("This Field is required"),
    national_id: yup.string().required("This Field is required"),
    // license_back: yup
    //   .mixed()
    //   .required("Image is required"),
    // license_front: yup
    //   .mixed()
    //   .required("Image is required"),
    // car_registration_front: yup
    //   .mixed()
    //   .required("Image is required"),
    // car_registration_back: yup
    //   .mixed()
    //   .required("Image is required"),
  });

export const addoffer = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
    english_banner: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
  });

export const home_addoffer = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });

export const InstantCode = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),

    coupon_code: yup.string(),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup.mixed().required("Image is required"),

    english_banner: yup.mixed().required("Image is required"),
  });

export const home_InstantCode = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),

    coupon_code: yup.string(),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });
export const add_offers_update = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup.number().required('This Field is required').positive('This Field is required'),
    //   minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup.mixed().required("Image is required"),

    english_banner: yup.mixed().required("Image is required"),
  });

export const home_add_offers_update = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== "",
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup.number().required('This Field is required').positive('This Field is required'),
    //   minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });

export const addDriverManagementValidation = (flag) =>
  yup.object({
    company_name: yup
      .string()
      .min(3, "Partner name must be at least 3 characters")
      .required("Partner name is required"),
    cr_number: yup
      .string()
      .matches(/^\d{10}$/, "CR number must be exactly 10 digits")
      .required("CR number is required"),
  });
export const addBulkValidation = (flag) =>
  yup.object({
    file_url: yup.string().required("This field is required"),
  });

export const addNotificationValidation = (flag) =>
  yup.object({
    subject: yup
      .string()
      .min(3, "Must be at least 3 characters")
      .required("This field is required"),
    description: yup
      .string()
      .min(5, "Must be at least 5 characters")
      .required("This field is required"),
    all_customers: yup
      .mixed()
      .oneOf([1, 0], "Type must be 1 or 0")
      .required("Type is required"),
  });

export const addEmailNotificationValidation = (flag) =>
  yup.object({
    subject: yup
      .string()
      .min(3, "Must be at least 3 characters")
      .required("This field is required"),
    description: yup
      .string()
      .min(5, "Must be at least 5 characters")
      .required("This field is required"),
    all_customers: yup
      .mixed()
      .oneOf([1, 0], "Type must be 1 or 0")
      .required("Type is required"),
  });
export const contactReqValidation = (flag) =>
  yup.object({
    landline: yup
      .string()
      .required("Landline number is required")
      .matches(/^[0-9]{6,12}$/, "Landline must be 6-12 digits"),
    whatsapp_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),
    instagram: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.-]+\/?$/,
        "Enter a valid Instagram profile URL",
      )
      .notRequired(),
    x: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?(x|twitter)\.com\/[A-Za-z0-9_]+\/?$/,
        "Enter a valid X (Twitter) profile URL",
      )
      .notRequired(),
    snap_chat: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?snapchat\.com\/add\/[A-Za-z0-9_.-]+\/?$/,
        "Enter a valid Snapchat profile URL",
      )
      .notRequired(),
    you_tube: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?youtube\.com\/(c|channel|user)\/[A-Za-z0-9_-]+\/?$/,
        "Enter a valid YouTube channel URL",
      )
      .notRequired(),
    face_book: yup
      .string()
      .nullable()
      .matches(
        /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9_.-]+\/?$/,
        "Enter a valid Facebook profile URL",
      )
      .notRequired(),
    // website: yup.string()
    //   .matches(
    //     // /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
    //     /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w .-]*)*\/?$/,
    //     'Enter a valid website URL'
    //   )
    //   .required('Website URL is required'),
  });

export const addSizeValidation = (flag) =>
  yup.object({
    name: yup
      .string()
      .min(3, "Name must be at least 3 characters")
      .required("Name is required"),
    ar_name: yup
      .string()
      .min(3, "Ar name must be at least 3 characters")
      .required("Ar name is required"),
  });

export const addOccassionValidation = (flag) =>
  yup.object({
    name: yup
      .string()
      .min(3, "Name must be at least 3 characters")
      .required("Name is required"),
    ar_name: yup
      .string()
      .min(3, "Ar name must be at least 3 characters")
      .required("Ar name is required"),
  });

export const addBrandValidation = yup.object({
  name: yup
    .string()
    .min(3, "Name must be at least 3 characters")
    .required("Name is required"),
});

export const addTypeValidation = yup.object({
  name: yup
    .string()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  ar_name: yup
    .string()
    .min(2, "Ar name must be at least 2 characters")
    .required("Ar name is required"),
  status: yup
    .number()
    .oneOf([1, 2], "Status must be either Active or Inactive")
    .required("Status is required"),
});

export const addColorValidation = (flag) =>
  yup.object({
    name: yup
      .string()
      .min(3, "Name must be at least 3 characters")
      .required("Name is required"),
    ar_name: yup
      .string()
      .min(3, "Ar name must be at least 3 characters")
      .required("Ar name is required"),
    status: yup
      .number()
      .oneOf([1, 2], "Status must be either 1 or 2")
      .required("Status type  is required"),
    hex_code: yup.string().required("This Field is required"),
  });

export const deliveryCharges = (flag) => yup.object({});

export const addProductValidation = ({
  canSeeCost = true,
  canSeeRegularPrice = true,
  canSeeSalePrice = true,
} = {}) =>
  yup.object({
    is_ingredient: yup.number(),
    ingredients: yup.array().when("is_ingredient", {
      is: 1,
      then: (schema) =>
        schema.min(1, "At least one ingredient is required").of(
          yup.object().shape({
            ingredient_id: yup.number().required("Ingredient is required"),
            quantity_required: yup
              .number()
              .required("Quantity is required")
              .min(0.01, "Must be greater than 0"),
            cost_per_unit: yup.number().required("Cost is required"),
          }),
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
    quantity: yup.number().required("Quantity is required."),
    // .min(1, "Quantity must be at least 1."),
    name: yup
      .string()
      .required("Name is required")
      .min(3, "Name must be at least 3 characters long"),
    ar_name: yup
      .string()
      .required("Arabic Name is required")
      .min(3, "Arabic Name must be at least 3 characters long"),
    description: yup
      .string()
      .required("Description is required")
      .min(10, "Description must be at least 10 characters long"),
    ar_description: yup
      .string()
      .required("Arabic Description is required")
      .min(10, "Arabic Description must be at least 10 characters long"),
    cost: canSeeCost
      ? yup
          .number()
          .typeError("Cost must be a number")
          .required("Cost is required")
          .min(0, "Cost must be at least 0")
      : yup.mixed().notRequired(),
    regular_price: canSeeRegularPrice
      ? yup
          .number()
          .typeError("Regular Price must be a number")
          .required("Regular Price is required")
      : yup.mixed().notRequired(),
    sale_price: canSeeSalePrice
      ? yup
          .number()
          .typeError("Sale Price must be a number")
          .nullable()
          .min(0, "Sale Price must be at least 0")
      : yup.mixed().notRequired(),
    images: yup
      .array()
      .of(
        yup.object({
          image_urls: yup.object().required(),
        })
      )
      .min(1, "At least one image is required")
      .required("At least one image is required"),
    //   status: yup.string().required("Status is required."),
    //   type: yup.string().required("Product Type is required."),
    category_ids: yup.array().when("type", {
      is: (val) => val !== 4 && val !== 6,
      then: (schema) =>
        schema
          .required("Please select any Category")
          .min(1, "At least one Category must be selected."),
      otherwise: (schema) => schema.notRequired(),
    }),
    sub_category_ids: yup
      .array()
      .min(1, "At least one Sub Category must be selected.")
      .required("Please select any Sub Category"),
    type_id: yup
      .number()
      .typeError("Product Type is required")
      .nullable()
      .required("Product Type is required"),
    is_b2b: yup
      .number()
      .oneOf([0, 1], "B2B must be Yes or No")
      .required("B2B is required"),
    brand_ids: yup.array().when("type", {
      is: (val) => val !== 4 && val !== 6,
      then: (schema) =>
        schema
          .required("Please select any Brand")
          .min(1, "At least one Brand must be selected."),
      otherwise: (schema) => schema.notRequired(),
    }),
    // occasion_ids:  yup.array().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Please select any Occasion").min(1, "At least one Occasion must be selected."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    barcode: yup
      .string()
      .transform((val) =>
        typeof val === "string" ? val.trim().toUpperCase() : val,
      )
      .required("Barcode is required.")
      .max(32, "Barcode cannot exceed 32 characters.")
      .matches(
        /^[A-Z0-9\-/.]+$/,
        "Invalid barcode format. Use letters, digits, dash, slash, or dot only.",
      ),

    // quantity:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Quantity is required.")
    //   .min(1, "Quantity must be at least 1."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    // is_cake: yup.boolean(),

    // color:  yup.string().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Color is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // size:  yup.string().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Size is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    // height:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Height is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // width:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Width is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // delivery_time:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Duration time is required.").min(1, "Duration must be greater than 1."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    //   delivery_time: yup.number().when("type", {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.min(1, "Duration must be greater than 1."),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // position:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Position is required.").min(1, "Position must be greater than 1."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
    // delivery_from: yup.date().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Delivery From date is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    //delivery_from: yup.date().notRequired(),

    // delivery_to: yup.date().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("Delivery to date is required.").min(yup.ref("delivery_from"), "Delivery To date must be after Delivery From date."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    //delivery_to: yup.date().min(yup.ref("delivery_from"), "Delivery To date must be after Delivery From date.").notRequired(),

    // new_from: yup.date().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("New from date is required."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    //new_from: yup.date().notRequired(),

    // new_to: yup.date().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("New to date is required.").min(yup.ref("new_from"), "New To date must be after Delivery From date."),
    //   otherwise: (schema) => schema.notRequired()
    // }),

    //new_to: yup.date().min(yup.ref("new_from"), "New To date must be after New From date.").notRequired(),

    // order_in_view:  yup.number().when('type', {
    //   is: (val) => val !== 4 && val !== 6,
    //   then: (schema) => schema.required("order in view is required.").min(1, "order in view must be at least 1."),
    //   otherwise: (schema) => schema.notRequired()
    // }),
  });
